import React from 'react';
import TableHead from './TableHead';
import TableBody from './TableBody';
import Pagination from './CardFooter';
import TableRow from './TableRow';

class Table extends React.Component {
    constructor(props) {
        super(props);

        const { establishments } = this.props;

        this.state = {
            establishments: establishments,
            pageOfItems: [],
        };

        this.onChangePage = this.onChangePage.bind(this);
    }
    onChangePage(pageOfItems) {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
    }
    render(){
        const empty = (this.state.establishments.length === 0);
        if (empty) {
            return (
                <div className="rounded-0 alert alert-warning m-0">
                    Nenhum estabelecimento cadastrado.
                </div>
            ); 
        }
        return(
            <div className="table-responsive">
                <table className="table align-items-center table-flush">
                    <TableHead />
                    {this.state.pageOfItems.map(item =>
                        <TableRow key={item.id} {...item} />
                    )}
                </table>
                <Pagination items={this.state.establishments} onChangePage={this.onChangePage}/>
            </div>
        );
    }
};

export default Table;


// WEBPACK FOOTER //
// ./src/components/Pages/Establishments/Table.js